import { TableCell, TableRow } from '@carbon/react';
import classNames from 'classnames';
import { TrashButton } from 'components/trash-button';
import { FC, ReactNode } from 'react';

import style from './removable-row.module.scss';

interface Props {
  removable?: boolean;
  className?: string;
  markedForDestruction: boolean;
  onRemove: (rowIndex: number) => void;
  index: number;
  children?: ReactNode;
}

const RemovableRow: FC<Props> = ({
  removable = true,
  onRemove,
  className,
  children,
  markedForDestruction,
  index,
  ...rest
}) => {
  className = classNames(className, style.removable, {
    [style.markedForDestruction]: markedForDestruction,
  });

  return (
    <>
      <TableRow className={className} {...rest}>
        {children}
        <TableCell {...({ align: 'right' } as any)}>
          {removable && (
            <TrashButton
              className={style.destroy}
              kind={markedForDestruction ? 'danger' : 'ghost'}
              size="sm"
              description="Remove"
              onClick={() => {
                onRemove(index);
              }}
            />
          )}
        </TableCell>
      </TableRow>
    </>
  );
};

export { RemovableRow };
